import type { TMessages } from '@/types/TMessages'

export const messages = {
  field: {
    deliveryVolume: {
      label: 'Объем поставки',
      loading: 'рассчитываем...',
      valueUnit: '{value, plural, one {тонна} few {тонны} other {тонн}}',
      unknownValue: '-',
    },
  },
  button: {
    submitApplication: 'Подать заявку',
    requestConsultation: 'Запросить консультацию',
  },
  increaseLoanAmountBanner: {
    comment: 'Заявка на отчет из калькулятора Авансирования',
  },
} satisfies TMessages
